import { OperationType, ROUTE_PATH } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class NotificationGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Notifications',
            ROUTE_PATH.notificationgrid,
            ROUTE_PATH.notificationAdd,
            true,
            true,
            8,
            false,
            true,
            ['content'],   //For search
            false,
            [],
            // { isDownloadExcel: true, excelFileName: 'Notification'+ new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download Notification', headers: [{ key: 'text', value: 'content' }, { key: 'sentTo', value: 'students' },  { key: 'sentOn', value: 'display_datetime' }, { key: 'sentBy', value: 'type' } ,] },
            // { isDownloadExcel: true, excelFileName: 'Notification' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download Notification', headers: [{ key: 'Text', value: 'content' },{ key: 'sentOn', value: 'display_datetime' },{ key: 'sentBy', value: 'type' },{ key: 'branch', value: 'branch' },{ key: 'region', value: 'region' },{ key: 'group', value: 'group' }, { key: 'created', value: 'created' },{ key: 'sentTo', value: 'students' },] },
            { isDownloadExcel: true,
                excelFileName:
                'Announcement List' + new Date().toLocaleDateString() + '.xlsx',
                btnLabel: 'Download Notification',
                headers: [
                    { key: 'Content', value: 'content' },                    
                    { key: 'Sent On', value: 'display_datetime' },
                    { key: 'Announcement Type', value: 'type' },
                    { key: 'Sent To', value: 'sendTo' },
                    { key: 'Sent By', value: 'type' },
                    { key: 'Student Name', value: 'student_name'},
                    { key: 'Batch', value: 'batch_number' },
                    { key: 'Group', value: 'group'},
                    { key: 'Branch', value: 'branch' },
                    { key: 'Region', value: 'region' },
                    { key: 'Created', value: 'sent_datetime' },
                ]
            },

            false,
            null,
            false,
            false,
            true,
            null,
            null,
            false,
            null,
            null,
            {
                isTabSwitch: false,
                label: '',
                isChecked: false,
              },
            true,
            true,
            true,
            [],
            false
        );
    }
 
    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        // const text = new Headers('Text', 'content', false, true, 'text');
        const text = new Headers('Text', 'content', false, true, 'text', '0', {
            isColumnNavigation: true,
            navigationUrl: ROUTE_PATH.notificationAdd,
            navigateOperationType: OperationType.UPDATE,
            navigateTransferData: new WidgetModel(),
            navigatePageName: 'View notification',
            
          });
        const sentTo = new Headers('Sent To', 'student', false, true, 'textUrl');
        const sentOn = new Headers('Sent On', 'display_datetime', false, true, 'text');
        const sentBy = new Headers('Sent By', 'type', false, true, 'text');
        // const branch = new Headers('branch', 'group', false, true, 'text');
        // const region = new Headers('region', 'region', false, true, 'text');
        // const created = new Headers('created', 'type', false, true, 'text');
        
        headers.push(text);
        // headers.push(username);
        headers.push(sentTo);
        headers.push(sentOn);
        headers.push(sentBy);
        return headers;
    }
}